export default __webpack_public_path__ + "static/media/textbg01@2x.c9e18317.png";